'use client'

import { useTranslations } from 'next-intl'

import { useShallow } from 'zustand/react/shallow'

import { isForceGraftcodeOnboardingEnabled } from '@common/helpers'

import { selectGraftcodeOnboardingWizardUi } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.selector'
import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

import { GRAFTCODE_ONBOARDING_WIZARD_STEP } from '../../graftcode-onboarding.const'
import { GRAFTCODE_ONBOARDING_TEST_IDS } from '../../graftcode-onboarding-test-ids.const'

import { GraftcodeOnboardingGoalStep } from './GraftcodeOnboardingGoalStep'
import { GraftcodeOnboardingScenarioStep } from './GraftcodeOnboardingScenarioStep'

import styles from './GraftcodeOnboardingWizard.module.scss'

export function GraftcodeOnboardingWizard() {
  const t = useTranslations('graftcodeOnboarding')
  const { wizardStep, goalId, setGoal, goToScenarioStep, goToGoalStep, completeWizard } = useGraftcodeOnboardingStore(
    useShallow(selectGraftcodeOnboardingWizardUi)
  )

  return (
    <div className={styles.screen} data-testid={GRAFTCODE_ONBOARDING_TEST_IDS.root}>
      {isForceGraftcodeOnboardingEnabled() ? <p className={styles.devBanner}>{t('devBanner')}</p> : null}
      <section
        className={styles.dialog}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="graftcode-onboarding-title"
        data-testid={GRAFTCODE_ONBOARDING_TEST_IDS.shell}
      >
        {wizardStep === GRAFTCODE_ONBOARDING_WIZARD_STEP.goal ? (
          <GraftcodeOnboardingGoalStep selectedGoalId={goalId} onSelectGoal={setGoal} onContinue={goToScenarioStep} />
        ) : (
          <GraftcodeOnboardingScenarioStep onBack={goToGoalStep} onSelectScenario={completeWizard} />
        )}
      </section>
    </div>
  )
}
